// Prepends assetHost to the webpack public path for fetching assets.
// Enables swapping to S3 or a CDN.
const {assetsHost} = window.ENV;
if (assetsHost) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = `${assetsHost}${process.env.PUBLIC_PATH}`;
}